import moment from 'moment';
import get from 'rc-util/lib/utils/get';
import isNil from '../isNil';
var dateFormatterMap = {
  time: 'HH:mm:ss',
  timeRange: 'HH:mm:ss',
  date: 'YYYY-MM-DD',
  dateWeek: 'YYYY-wo',
  dateMonth: 'YYYY-MM',
  dateQuarter: 'YYYY-QQ',
  dateYear: 'YYYY',
  dateRange: 'YYYY-MM-DD',
  dateTime: 'YYYY-MM-DD HH:mm:ss',
  dateTimeRange: 'YYYY-MM-DD HH:mm:ss'
};

function isObject(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

export function isPlainObject(o) {
  if (isObject(o) === false) return false; // If has modified constructor

  var ctor = o.constructor;
  if (ctor === undefined) return true; // If has modified prototype

  var prot = ctor.prototype;
  if (isObject(prot) === false) return false; // If constructor does not have an Object-specific method

  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  } // Most likely a plain Object


  return true;
}

var convertMoment = function convertMoment(value, dateFormatter, valueType) {
  if (moment.isMoment(value)) {
    if (dateFormatter === 'number') {
      return value.valueOf();
    }

    return value.format(dateFormatterMap[valueType] || 'YYYY-MM-DD HH:mm:ss');
  }

  return value;
};
/**
 * 根据不同的格式转化 moment
 * @param value
 * @param dateFormatter
 * @param valueType
 */


var conversionMoment = function conversionMoment(value, dateFormatter, valueType) {
  if (!dateFormatter) {
    return value;
  }

  if (!Array.isArray(value)) {
    return convertMoment(value, dateFormatter, valueType);
  }

  return value.map(function (item) {
    return convertMoment(item, dateFormatter, valueType);
  });
};
/**
 * 这里主要是来转化一下数据
 * 将 moment 转化为 string
 * 将 all 默认删除
 * @param value
 * @param dateFormatter
 * @param proColumnsMap
 */


var conversionSubmitValue = function conversionSubmitValue(value, dateFormatter, valueTypeMap, parentKey) {
  var tmpValue = {};
  Object.keys(value).forEach(function (key) {
    var namePath = parentKey ? [parentKey, key] : [key];
    var valueType = get(valueTypeMap, namePath) || 'text';
    var itemValue = value[key];

    if (isNil(itemValue)) {
      return;
    }

    if (isPlainObject(itemValue)) {
      tmpValue[key] = conversionSubmitValue(itemValue, dateFormatter, valueTypeMap, key);
      return;
    } // 都没命中，原样返回


    tmpValue[key] = conversionMoment(itemValue, dateFormatter, valueType);
  });
  return tmpValue;
};

export default conversionSubmitValue;